<div class="table-layout">
  <div class="table-main">
    <div style="
        margin-right: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      ">
      <div class="table-toolbar">
        @if (this.inMenuButtonConfig.length > 0) {
        <button mat-icon-button [matMenuTriggerFor]="menu" style="display: flex; height: 41px" aria-label="options">
          <span style="rotate: 90deg" nz-icon nzType="ellipsis" nzTheme="outline"></span>
        </button>
        }
        <ng-content></ng-content>
        @for (config of this.buttonConfig; track config) {
        <button mat-raised-button (click)="config.action($event, this.filteredData)">
          {{ config.text }}
        </button>
        }
        <button mat-raised-button (click)="this.removeAllFilters()">
          Clear All Filters
        </button>
        <button (click)="this.showAppliedFilterDialog()" mat-raised-button>
          Show applied filters
        </button>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="template"></ng-container>
    @if (this.diffJob) {
    <div>
      All jobs are currently being compared to {{ this.diffJob }}
    </div>
    }
    @if (this.data.length > 0) {
    <div class="custom-data-table-container" [style.overflow]="this.loading ? 'hidden' : 'auto'">
      <table class="data-table styled-table">
        <thead>
          <tr>
            @if (this.collapsibleDetail) {
            <th></th>
            }
            @for (key of this.displayKeysArray; track key) {
            <th [class]="'key-table-heading ' + key.key" (click)="sorter(key.key)" [style.position]="
                this.stickyFieldKeys.includes(key.key) ? 'sticky' : ''
              " [style.left]="this.stickyFieldKeys.includes(key.key) ? '0px' : ''" nz-tooltip [nzTooltipTitle]="
                headerTooltips[key.key] || headerTooltipsAccessor(key.key) || ''
              ">
              <div>
                <span>
                  {{ key.label }}
                </span>
                <div style="
                    width: 50px;
                    display: flex;
                    justify-content: flex-end;
                    gap: 5px;
                    align-items: baseline;
                  ">
                  @if (this.sortingKey == key.key) {
                  @if (this.sortingMode == 'asc') {
                  <i class="zmdi zmdi-long-arrow-up"></i>
                  } @else {
                  <i class="zmdi zmdi-long-arrow-down"></i>
                  }
                  } @else {
                  <span></span>
                  }
                  <div nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" [nzClickHide]="false"
                    (click)="$event.stopPropagation()" [class]="
                      this.getObjectKeys(this.headerFilterationObject).includes(
                        key.key
                      )
                        ? 'filters-box-selector'
                        : 'filters-box-selector not-filtered'
                    ">
                    <i class="fa-solid fa-filter"></i>
                  </div>
                  <nz-dropdown-menu #menu="nzDropdownMenu" [nzClickHide]="false">
                    <div nz-menu class="filter-dropdown-menu">
                      <nz-input-group class="legacy-input-styling">
                        <label>Search</label>
                        <input nz-input type="search" #searchOptions (change)="getFilterValuesForColumn(
                              key.key,
                              searchOptions
                            )">
                      </nz-input-group>
                      <ul class="filter-options-list">
                        @for (
                        item of filteredValuesForColumn[key.key]; track
                        item) {
                        <li nz-menu-item>
                          <label nz-checkbox [ngModel]="
                              this.headerFilterationObject[key.key]
                                ? !this.headerFilterationObject[
                                    key.key
                                  ].includes(item)
                                : true
                            " (ngModelChange)="
                              this.searchFilterSelected($event, key.key, item)
                            ">
                            @if (item) {
                            <span style="display: -webkit-box;
                                          -webkit-line-clamp: 2;
                                          line-clamp: 2;
                                          -webkit-box-orient: vertical;
                                          overflow: hidden;
                                          text-overflow: ellipsis;
                                          word-break: break-all;
                                          ">
                              {{ item }}
                            </span>
                            } @else {
                            <span style="color: #ccc; font-style: italic">
                              None
                            </span>
                            }
                          </label>
                        </li>
                        }
                      </ul>
                      <div class="filter-actions">
                        <button nzBlock nzSize="small" nz-button nzType="primary" (click)="runSearch()">Apply</button>
                        <div class="filter-bulk-actions">
                          <button nzBlock nzSize="small" nz-button nzType="default"
                            (click)="selectAllShowing(key.key)">Select Showing</button>
                          <button nzBlock nzSize="small" nz-button nzType="default"
                            (click)="selectAllSearch(key.key)">Select All</button>
                          <button nzBlock nzSize="small" nz-button nzType="default"
                            (click)="deselectAllSearch(key.key)">Deselect All</button>
                        </div>
                      </div>
                    </div>
                  </nz-dropdown-menu>
                </div>
              </div>
            </th>
            }
            @if (this.editRow || this.deleteRow) {
            <th class="action-column">
              &nbsp;
            </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (
          row of this.filteredData.slice(
          this.currentPage * this.pageSize,
          (this.currentPage + 1) * this.pageSize
          )
          ; track
          row) {
          <tr [id]="rowIdKey ? row[this.rowIdKey] : ''" [style.background]="
                this.highlightControlKey &&
                !row[this.highlightControlKey] &&
                this.highlightColor
              " #parentRow>
            @if (this.collapsibleDetail) {
            <td class="collapsible-row-trigger" (click)="activateRowCollapse(parentRow, row)">
              <div><i class="zmdi zmdi-plus-circle-o"></i></div>
            </td>
            }
            @for (obj of this.displayKeysArray; track obj) {
            <td [innerHTML]="this.getEntryValue(row[obj.key], obj.key, row)" [class]="obj.key" [style.position]="
                  this.stickyFieldKeys.includes(obj.key) ? 'sticky' : ''
                " [style.left]="
                  this.stickyFieldKeys.includes(obj.key) ? '0px' : ''
                "></td>
            }
            @if (this.editRow || this.deleteRow) {
            <td class="action-column">
              @if (this.editRow) {
              <span (click)="this.editRowHandler.emit(row)"><i class="zmdi zmdi-edit"></i></span>
              }
              @if (this.deleteRow) {
              <span (click)="this.deleteRowHandler.emit(row)"><i class="zmdi zmdi-delete"></i>Delete</span>
              }
            </td>
            }
          </tr>
          @if (this.collapsibleDetail) {
          <tr class="row-collapsible-detail" [id]="'collapsible-row-' + row[this.rowIdKey]">
            <!-- Can add to inner HTML here, but better to get it on collapse. Lesser function calls. Check function activateRowCollapse for innerHTML assignment  -->
            <!-- [innerHTML]="this.collapsibleBodyFunction(row)" -->
            <td colspan="100%"></td>
          </tr>
          }
          }
        </tbody>
      </table>
      @if (this.loading) {
      <div id="data-table-loader">
        <div class="loader"></div>
      </div>
      }
    </div>
    <span> Showing {{ this.showingRows }} out of {{ this.totalRows }} </span>
    @if (this.pageCount > 1) {
    <div>
      <div class="pagination">
        <ul class="page">
          <li class="page__btn" (click)="
              !this.loading &&
                (this.currentPage =
                  this.currentPage - 1 == -1
                    ? this.pageCount - 1
                    : this.currentPage - 1)
            ">
            <i class="zmdi zmdi-chevron-left"></i>
          </li>
          @for (index of [].constructor(this.pageCount); track $index) {
          <li [class]="
              this.currentPage == $index ? 'page__numbers active' : 'page__numbers'
            " (click)="this.currentPage = $index">
            {{ $index + 1 }}
          </li>
          }
          <li class="page__btn" (click)="
              !this.loading &&
                (this.currentPage = (this.currentPage + 1) % this.pageCount)
            ">
            <i class="zmdi zmdi-chevron-right"></i>
          </li>
        </ul>
      </div>
    </div>
    }
    } @else {
    <div class="custom-data-table-container">
      @if (this.loading) {
      <div class="empty-data-table">Loading</div>
      <div id="data-table-loader">
        <div class="loader"></div>
      </div>
      } @else {
      <div class="empty-data-table">No data to show</div>
      }
    </div>
    }
  </div>
  <div class="table-sidebar">
    <app-parameter-filter-box (selected)="this.applyColumnHiding($event)" (applyDiff)="this.applyDiff($event)"
      (showChangingColumns)="this.showChangingColumns()" [isParameterView]="this.isParameterView" [jobs]="this.data"
      [options]="this.columns" [parameterViewMatchingOptions]="this.matchingJobOptions"
      [showChangingColumnsControl]="this.showChangingColumnsControl"
      [defaultSelectedColumns]="this.defaultSelectedColumns" [alawysSelectedColumns]="['job_name', 'diff']">
    </app-parameter-filter-box>
  </div>
</div>

<mat-menu #menu="matMenu">
  @for (config of this.inMenuButtonConfig; track config) {
  <button mat-menu-item (click)="config.action($event, this.filteredData, this.displayKeysArray)">
    {{ config.text }}
  </button>
  }
</mat-menu>